import wx from 'weixin-js-sdk'

/**
 *   Toast公共方法
 */

export function loadJssdk(lineLink, imgUrl, shareTitle, descContent) {
  console.log('11111',lineLink, imgUrl, shareTitle, descContent);
  return new Promise((resolve, reject) => {
    wx.onMenuShareTimeline({
      title: shareTitle, // 分享标题
      link: lineLink, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function () {
        console.log(1243)
        resolve(2)
      },
      cancel: function () {
        reject("cancel")
      }
    });
    wx.onMenuShareAppMessage({
      desc: descContent, // 分享描述
      title: shareTitle, // 分享标题
      link: lineLink, // 分享链接
      imgUrl: imgUrl, // 分享图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        resolve(1)
      },
      cancel: function () {
        reject()
      }
    });
  })
}

export function pt_TouchToClick(func, event, ...args) {
  console.log(event);
  return function () {
    const context = this;
    func.apply(context, arguments)
  }
}

// 计算时间
function getDateDiff(dateStr) {
  let publishTime = getDateTimeStamp(dateStr) / 1000,
    d_seconds,
    d_minutes,
    d_hours,
    d_days,
    timeNow = parseInt(new Date().getTime() / 1000),
    d,

    date = new Date(publishTime * 1000),
    Y = date.getFullYear(),
    M = date.getMonth() + 1,
    D = date.getDate(),
    H = date.getHours(),
    m = date.getMinutes(),
    s = date.getSeconds();
  //小于10的在前面补0
  if (M < 10) {
    M = '0' + M;
  }
  if (D < 10) {
    D = '0' + D;
  }
  if (H < 10) {
    H = '0' + H;
  }
  if (m < 10) {
    m = '0' + m;
  }
  if (s < 10) {
    s = '0' + s;
  }

  d = timeNow - publishTime;
  d_days = parseInt(d / 86400);
  d_hours = parseInt(d / 3600);
  d_minutes = parseInt(d / 60);
  d_seconds = parseInt(d);

  if (d_days > 0 && d_days < 3) {
    return d_days + '天前';
  } else if (d_days <= 0 && d_hours > 0) {
    return d_hours + '小时前';
  } else if (d_hours <= 0 && d_minutes > 0) {
    return d_minutes + '分钟前';
  } else if (d_seconds < 60) {
    if (d_seconds <= 0) {
      return '刚刚';
    } else {
      return d_seconds + '秒前';
    }
  } else if (d_days >= 3 && d_days < 30) {
    return M + '-' + D + ' ' + H + ':' + m;
  } else if (d_days >= 30) {
    return Y + '-' + M + '-' + D + ' ' + H + ':' + m;
  }
}

// 获取据当前时间
function getDateTimeStamp(dateStr) {
  return Date.parse(dateStr.replace(/-/gi, "/"));
}

/**
 * 动态改变文本输入框高度
 * */
function autoTextarea(elem, extra, maxHeight) {
  extra = extra || 0;
  let isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window,
    isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera'),
    addEvent = function (type, callback) {
      elem.addEventListener ? elem.addEventListener(type, callback, false) : elem.attachEvent('on' + type, callback);
    },
    getStyle = elem.currentStyle ? function (name) {
      let val = elem.currentStyle[name];
      if (name === 'height' && val.search(/px/i) !== 1) {
        let rect = elem.getBoundingClientRect();
        return rect.bottom - rect.top - parseFloat(getStyle('paddingTop')) - parseFloat(getStyle('paddingBottom')) + 'px';
      }

      return val;
    } : function (name) {
      return getComputedStyle(elem, null)[name];
    },
    minHeight = parseFloat(getStyle('height'));
  elem.style.resize = 'none';
  let change = function () {
    let scrollTop, height, padding = 0, style = elem.style;

    if (elem._length === elem.value.length) return;
    elem._length = elem.value.length;

    if (!isFirefox && !isOpera) {
      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
    }
    scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    elem.style.height = minHeight + 'px';
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding;
        style.overflowY = 'auto';
      } else {
        height = elem.scrollHeight - padding;
        style.overflowY = 'hidden';
      }
      style.height = height + extra + 'px';
      scrollTop += parseInt(style.height) - elem.currHeight;
      document.body.scrollTop = scrollTop;
      document.documentElement.scrollTop = scrollTop;
      elem.currHeight = parseInt(style.height);
    }
  };

  addEvent('propertychange', change);
  addEvent('input', change);
  addEvent('focus', change);
  change();
}

/**
 * 判断对象数组中的对象是否包含某个值
 *
 * @param {Array} arr 需要判断的数组
 * @param {String} key 需要判断的Key
 * @param {*} val 判断的值
 * @return {number} 返回坐标
 */
function determineObjectForArray(arr, key, val) {
  for (let i = 0; i < arr.length; i++) {
    if (key) {
      if (arr.hasOwnProperty(i)) {
        const element = arr[i];
        if (element[key] === val) {
          return i;
        }
      }
    } else {
      let i = arr.length;
      while (i--) {
        if (arr[i] === val) {
          return i;
        }
      }
    }
  }
  return -1;
}

/**
 * 判断数组中是否包含某个值
 *
 * @param {Array} arr 数组
 * @param {*} val 需要判断的值
 */
function includeArray(arr, val) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] == val) {
      return true;
    }
  }
  return false;
}


/**
 * 判断是否为 iPhone X、iPhone XS、iPhone XS Max、iPhone XR
 * */
function isIphoneXSeries () {
  // iPhone X、iPhone XS
  let isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
  // iPhone XS Max
  let isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
  // iPhone XR
  let isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
  if (isIPhoneX || isIPhoneXR || isIPhoneXSMax) {
    return true;
  }
  return false;
}

export default {
  autoTextarea: autoTextarea,
  determineObjectForArray: determineObjectForArray,
  includeArray: includeArray,
  getDateDiff: getDateDiff,
  isIphoneXSeries: isIphoneXSeries
}



// WEBPACK FOOTER //
// ./src/utils/tool.js